<ul [class.breadcrumb]="useBootstrap" class="custom-breadcrumb-container">
  @for (breadcrumb of breadcrumbs$ | async; let last = $last; track $index) {
    <li [ngClass]="{'breadcrumb-item': useBootstrap, active: last}">
      @if (!last) {
        <a
          role="button"
          (click)="navigateTo(breadcrumb.url)"
          (keydown.enter)="navigateTo(breadcrumb.url)"
          >{{ breadcrumb.label }}</a
        >
      }
      @if (last) {
        <span>{{ breadcrumb.label }}</span>
      }
    </li>
  }
</ul>
